import { __decorate, __metadata } from "tslib";
import { Component, Prop, Ref } from "vue-property-decorator";
import LvControlPopover from "../control-popover/LvControlPopover.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvDropdown";
/**
 * A dropdown component
 */
let LvDropdown = class LvDropdown extends UIComponent {
    /**
     * Show the dropdown
     */
    show() {
        this.popover.show();
    }
    /**
     * Hide the dropdown
     */
    hide() {
        this.popover.hide();
    }
    /**
     * Show or hide the dropdown
     */
    toggle() {
        this.popover.toggle();
    }
};
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvDropdown.prototype, "autoClose", void 0);
__decorate([
    Ref(),
    __metadata("design:type", LvControlPopover)
], LvDropdown.prototype, "popover", void 0);
LvDropdown = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvControlPopover },
    })
], LvDropdown);
export default LvDropdown;
//# sourceMappingURL=script.js.map